import * as React from "react"

import { cn } from "@garagem/ui/lib/utils"

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  "data-testid"?: string
  ref?: React.Ref<HTMLInputElement>
}

function Input({
  className,
  type,
  "data-testid": dataTestId,
  ref,
  ...props
}: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      data-testid={dataTestId}
      ref={ref}
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground/60 selection:bg-primary selection:text-primary-foreground dark:bg-white/30 border flex h-9 w-full min-w-0 rounded-md border bg-white px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-white file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus:ring-4 focus:ring-primary/40 focus:border-primary",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  )
}

export { Input }
